export default {
      id: "statements-downloaded-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#statements-downloaded",
      toString: function () {
        return this.url;
      }
    }